module.exports = __webpack_public_path__ + "img/DCS_0125-28.181334c7.jpg";